
$(document).ready(function(){

  const $body = $('body');
 
  // General Message
  $('.generalmessage').prependTo('header');

  $('#footer-signup-btn').on('keypress click', function(event) {
    event.preventDefault();
    if (event.key === 'Enter' || event.type === 'click') {
      $('.header .emailSignup').click();
    }
  });

  if ($body.hasClass('subpage-theme')) {
    const firstImgUrl = $('.entityContainerRow.rowIndex-1 .ImageModule img').attr('data-src');

    const heroImg = `
      <div class="subpage-hero" style="background-image: url('${firstImgUrl}');"></div>
    `;

    $(heroImg).insertAfter('.header');
  }


});

$(window).load(function(){

  setTimeout(function() {
    const wbdesc = $('#weatherBugDescription');
    wbdesc.hide();
    const wbtext = wbdesc.text();
    wbdesc.text(wbtext.slice(-4));
    $('#weatherBugWidget').css('display', 'flex');
    wbdesc.show();
  }, 1000);

	const $body = $('body');
  
  const subpageThemes = [
    {name: 'subpage-theme--chalk', img: 'logo-chalk.png'},
    {name: 'subpage-theme--visitvillage', img: 'logo-village.png'},
    {name: 'subpage-theme--treat', img: 'logo-treat.png'},
    {name: 'subpage-theme--pictures', img: 'logo-pictures.png'},
    {name: 'subpage-theme--5k', img: 'logo-5k.png'}
  ];
    
  function setLogoImages() {    
    let navLogo = 'logo.png';

    subpageThemes.forEach( theme => {
      if ($body.hasClass(theme.name)) {
        navLogo = theme.img;
      }
    });

    const navLogoHTML = `
      <li class="nav-logo">
        <a href="/" aria-label="arapahoe county fairgrounds">
          <img src="${FULLCLIENTTHEMEPATH}images/${navLogo}" alt="arapahoe county fairgrounds">
        </a>
      </li>
    `;
  
    const mobileLogo = `
      <a href="/" aria-label="arapahoe county fairgrounds">
        <img src="${FULLCLIENTTHEMEPATH}images/${navLogo}" class="m-logo" alt="arapahoe county fairgrounds">
      </a>
    `;  
    
    $(navLogoHTML).insertAfter('#mainNavigation .mainNavigationItem3');
    $(mobileLogo).prependTo('.header-bottom');
  }

  setLogoImages();

});